<div class="tableContainer table-mobile app-efulfillmentTable">
  <div class="tableTopSec">

    <div class="row">
      <div class="col-2 col-xl-4 col-lg-4 col-md-4 padding-l30">
        <mat-checkbox *ngIf="isAllCheckBoxEnable" data-testid="ddl-select-all" (click)="$event.stopPropagation()" [checked]="ngModel" [(ngModel)]="allChecked"
                      [indeterminate]="indeterminateCheck" (change)="allRowChecked($event)" class="custom-checkbox select-all-check"></mat-checkbox>
      </div>
      <div class="col-10 col-xl-8 col-lg-8 col-md-8 text-right mobile-pad-0">
        <mat-paginator #productPaginator [length]="length"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions"
                       (page)="onPaginatorChange($event)">
        </mat-paginator>
      </div>
    </div>
  </div>
  <div class="tableComponentOuter">
    <table class="matTables tableComponentInner mat-table acountTable" [ngClass]="isCellColorEnable ? 'sotAccountTable' : ' '" matSort (matSortChange)="sortData($event)" (window:resize)="onresize($event)">
      <thead>
        <tr class="mat-header-row">
          <th [class]="header?.className" *ngFor="let header of headerDS" [mat-sort-header]="header?.columnfield" [disabled]="header?.headertxt =='checkboxHeader' || header?.columnfield =='action'">
            <div *ngIf="header?.headertxt !='checkboxHeader'">
              {{header.headertxt}}
            </div>
            <div *ngIf="header?.headertxt =='checkboxHeader'">
              &nbsp;
            </div>
            <!--<mat-checkbox *ngIf="header?.headertxt =='checkboxHeader'" (click)="$event.stopPropagation()" [checked]="ngModel" [(ngModel)]="allChecked"
            [indeterminate]="indeterminateCheck" (change)="allRowChecked($event)" class="custom-checkbox select-all-check"></mat-checkbox>-->
          </th>
        </tr>
      </thead>
      <tbody *ngIf="paginatorDS.length != 0">
        <tr class="mat-row" *ngFor="let row of paginatorDS ; let i = index" [attr.data-testid]="row?.gmk ? ('grower-gmk-' + row.gmk) : null" (click)="onRowClicked($event, row, i)" [ngClass]="row.isAccountRowSelected ? 'highlight-row' : ''">
          <td class="mat-cell" *ngFor="let col of headerDS" [ngClass]="row.isAccountRowSelected ? 'highlight-cell' : ''">
            <div *ngIf="col?.headertxt =='B2B Enabled'" innerHTML="Yes">
              <span class="erp-order" *ngIf="row[col?.columnfield] == 'Yes'">
                <i class="fas fa-lock"></i>
              </span>
            </div>
            <div *ngIf="col?.headertxt !='B2B Enabled' && col?.headertxt !='checkboxHeader'" class="d-block d-md-none xs-label"> {{col.headertxt}}</div>
            <div *ngIf="col?.headertxt !='B2B Enabled' && col?.headertxt !='checkboxHeader' && col && row[col.columnfield + 'InnerHtml'] == null" (click)="onCellClicked($event,row, col.columnfield)">
              {{row[col?.columnfield]}}
            </div>
            <div *ngIf="col?.headertxt !='B2B Enabled' && col?.headertxt !='checkboxHeader' && col && row[col.columnfield + 'InnerHtml'] !=null" innerHTML="{{row[col.columnfield + 'InnerHtml']}}"
                 (click)="onCellClicked($event,row, col.columnfield)"></div>
            <div class="account-checkbox w-50" *ngIf="col?.headertxt =='checkboxHeader'">
              <mat-checkbox [attr.data-testid]="'ddl-specific-select_'+i" (click)="$event.stopPropagation()" [checked]="ngModel" [(ngModel)]="row[col?.columnfield]"
                            [style.display]="accessTypeModeAccount ? 'none' : 'block'" (change)="rowChecked($event,row)" class="custom-checkbox"></mat-checkbox>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="paginatorDS.length == 0">
        <tr>
          <td class="mat-cell noRecordMsg" [attr.colspan]=noRecordLength>
            No record Found.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
